<template>
  <div class="container col-md-8 offset-md-2 mt-5">
    <div class="card p-3 mb-3 card-lg shadow steps-card">
      <div class="container text-black">
        <div class="text-left my-3 font-25px steps-title">
          {{ titles[tab] }}
        </div>

        <!-- Start card content -->
        <div>
          <div v-show="tab === 1">
            <!-- <div class="form-row">
              <div class="col-lg-12 form-group">
                <select
                  class="custom-select form-control"
                  :class="{
                    'is-invalid': $v.otherInfo.business_incubator.$error,
                  }"
                  @focus="showHideLabel('business_incubator')"
                  @blur="showHideLabel('business_incubator')"
                  v-model.trim="$v.otherInfo.business_incubator.$model"
                  required
                >
                  <option :value="null" selected disabled class="custom-select-placeholder">{{ $t("which_business_incubator") }} *</option>
                  <option v-for="option in businessIncubatorSelect.options" :value="option.option_ita" :key="option.option_ita">
                    {{ option.option }}
                  </option>
                </select>
                <small v-show="otherInfo.business_incubator" id="business_incubator_label" style="display: block" class="mt-2">
                  {{ $t("which_business_incubator") }}
                  *</small
                >
              </div>
            </div> -->

            <div class="form-row mb-5">
              <div class="col-lg-12 form-group">
                <select
                  class="custom-select form-control"
                  :class="{
                    'is-invalid': $v.otherInfo.how_found_us.$error,
                  }"
                  @focus="showHideLabel('how_found_us')"
                  @blur="showHideLabel('how_found_us')"
                  v-model.trim="$v.otherInfo.how_found_us.$model"
                  required
                >
                  <option :value="null" selected disabled class="custom-select-placeholder">{{ $t("how_found_us") }} *</option>
                  <option v-for="option in howFoundUsSelect.options" :value="option.option_ita" :key="option.option_ita">
                    {{ option.option }}
                  </option>
                </select>
                <small v-show="otherInfo.how_found_us" id="how_found_us_label" style="display: block" class="mt-2">{{ $t("how_found_us") }} *</small>
              </div>
            </div>

              <div v-show="otherInfo.projectQueries && otherInfo.projectQueries.length > 0" class="form-row">
                  <div class="form-row col-lg-12" v-for="(projectQuery, pqi) in otherInfo.projectQueries">
                      <div class="col-lg-10 font-16px" v-html="projectQuery.description"></div>
                      <div class="col-lg-2 from-group">
                          <input v-model="projectQuery.response" type="radio" :name="'procedt[1]['+pqi+']'" :id="'procedt[1]['+pqi+']'" :value="1" class="radio-btn" />
                          <label :for="'procedt[1]['+pqi+']'" class="btn btn-checkbox mr-2">{{ $t("yes") }}</label>

                          <input v-model="projectQuery.response" type="radio" :name="'procedt[1]['+pqi+']'" :id="'procedt[0]['+pqi+']'" :value="0" class="radio-btn" />
                          <label :for="'procedt[0]['+pqi+']'" class="btn btn-checkbox mr-2">{{ $t("no") }}</label>
                      </div>
                  </div>
              </div>

              <div class="mb-20"></div>

          </div>

          <div class="mb-20" v-show="tab === 2">
            <div class="form-row">
              <div class="col-lg-12 form-group mb-3" v-for="award in awards" :key="award.id">
                <custom-checkbox v-model="award.selected">
                  {{ award.name }}
                </custom-checkbox>

                <div class="pl-4">
                  <p class="mb-0">{{ award.description }}</p>
                  <a :href="`/client/download-award-template/${award.id}`" target="_blank" style="color: #f2b12d" v-show="award.selected && award.needs_documentation"> scarica template </a>
                </div>

                <div class="input-group row ml-0 mt-3" v-show="award.selected && award.needs_documentation">
                  <div class="custom-file">
                    <input
                      :id="'award-' + award.id"
                      style="cursor: pointer"
                      accept=".pdf"
                      type="file"
                      class="custom-file-input"
                      v-on:change="handleFileUpload(award, 'award')"
                      :ref="'award_' + award.id"
                    />
                    <label v-show="!award.file" class="custom-file-label">{{ $t("upload_mention_award_document") }}</label>
                    <label v-show="award.file" class="custom-file-label">{{ award.file }}</label>
                  </div>
                  <div class="input-group-append custom-file-button bg-yellow mr-5">
                    <span v-show="!award.file" class="custom-file-text text-white">{{ $t("upload") }}</span>
                    <span v-on:click="openDeleteModal(award, 'award')" v-show="award.file" class="custom-file-text text-white" style="cursor: pointer">{{ $t("delete") }}</span>
                  </div>
                  <i v-show="!award.file && !loading_award_document" class="tio-done file-upload-icon" style="color: transparent"></i>
                  <i v-show="award.file" class="tio-done file-upload-icon" style="color: #9ac288"></i>
                  <i v-show="file_error" class="tio-clear file-upload-icon" style="color: #ff5b1e"></i>
                  <i v-show="loading_award_document" class="tio-autorenew file-loading-icon rotating" style="color: #ababab"></i>
                </div>
                <small v-show="award.file" class="mt-2">{{ $t("upload_mention_award_document") }}</small>
                <small class="text-danger" v-show="award.selected && !award.file && file_validation">{{ $t("obligatory_file") }}</small>
                <div class="mb-3"></div>
              </div>
            </div>
          </div>

          <div class="form-row mb-20" v-show="tab === 3">
            <div class="col-lg-12 form-group" v-for="mention in mentions" :key="mention.id">
              <custom-checkbox v-model="mention.selected">
                {{ mention.name }}
              </custom-checkbox>

              <div class="pl-4">
                <p class="mb-0">{{ mention.description }}</p>
                <a :href="`/client/download-mention-template/${mention.id}`" target="_blank" style="color: #f2b12d" v-show="mention.selected && mention.needs_documentation"> scarica template </a>
              </div>

              <div class="input-group row ml-0 mt-3" v-show="mention.selected && mention.needs_documentation">
                <div class="custom-file">
                  <input
                    :id="'mention-' + mention.id"
                    style="cursor: pointer"
                    accept=".pdf"
                    type="file"
                    class="custom-file-input"
                    v-on:change="handleFileUpload(mention, 'mention')"
                    :ref="'mention_' + mention.id"
                  />
                  <label v-show="!mention.file" class="custom-file-label">{{ $t("upload_mention_award_document") }}</label>
                  <label v-show="mention.file" class="custom-file-label">{{ mention.file }}</label>
                </div>
                <div class="input-group-append custom-file-button bg-yellow mr-5">
                  <span v-show="!mention.file" class="custom-file-text text-white">{{ $t("upload") }}</span>
                  <span v-on:click="openDeleteModal(mention, 'mention')" v-show="mention.file" class="custom-file-text text-white" style="cursor: pointer">{{ $t("delete") }}</span>
                </div>
                <i v-show="!mention.file && !loading_mention_document" class="tio-done file-upload-icon" style="color: transparent"></i>
                <i v-show="mention.file" class="tio-done file-upload-icon" style="color: #9ac288"></i>
                <i v-show="file_error" class="tio-clear file-upload-icon" style="color: #ff5b1e"></i>
                <i v-show="loading_mention_document" class="tio-autorenew file-loading-icon rotating" style="color: #ababab"></i>
              </div>
              <small v-show="mention.file" class="mt-2">{{ $t("upload_mention_award_document") }}</small>
              <small class="text-danger" v-show="mention.selected && !mention.file && file_validation">{{ $t("obligatory_file") }}</small>
              <div class="mb-3"></div>
            </div>
          </div>

          <!-- navigator -->
          <div
            class="p-5 wizard_navigator custom-row justify-content-between justify-content-center text-white font-lato-regular fixed-bottom sticky-bottom-bar"
            data-offset="-60"
            style="background-color: #f2b12d"
          >
            <div class="font-16px hover-mouse-pointer" @click="previous()">
              <i class="tio-arrow-left-circle-outlined font-25px"></i>
              {{ $t("back") }}
            </div>
            <div class="font-16px hover-mouse-pointer" @click="next()">
              {{ $t("forward") }}
              <i class="tio-arrow-right-circle-outlined font-25px"></i>
            </div>
          </div>
        </div>
        <!-- End Card content-->
      </div>
    </div>
    <div class="col-12 text-center mt-6 stick-up-bottom-element">
      <button v-on:click="saveForLater" class="btn btn-secondary">
        {{ $t("save_and_continue") }}
      </button>
    </div>
    <div class="modal fade" id="remove_file_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $t("remove_file") }}
            </h5>
            <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
              <i class="tio-clear tio-lg"></i>
            </button>
          </div>
          <div class="modal-body">
            {{ $t("sure_to_remove_file") }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              {{ $t("cancel") }}
            </button>
            <button type="button" @click="removeFile()" class="btn btn-primary">
              {{ $t("confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "OtherInfo",
  props: ["projectProp", "route", "previousRoute", "awardsProp", "mentionsProp", "fileRoute", "deleteFileRoute", "businessIncubatorSelect", "howFoundUsSelect", "editionQueriesProp"],
  mounted() {

    this.otherInfo = this.projectProp;
    this.mentions = this.mentionsProp;
    this.awards = this.awardsProp;

    this.otherInfo.projectQueries = [];
      // indicizzo le domande di project per id
      let projectQueriesIndexed = [];
      this.projectProp.project_queries.forEach(query => {
          projectQueriesIndexed[query.edition_query_id] = query.response;
      });

      this.editionQueriesProp.forEach(editionQuery => {
          this.otherInfo.projectQueries.push({
              "description": editionQuery.description,
              "edition_query_id": editionQuery.id,
              "response": projectQueriesIndexed[editionQuery.id] != undefined ? projectQueriesIndexed[editionQuery.id] : null
          });
      });

    $("#datatableWithFilter").on("page.dt", function (p) {
      setTimeout(() => {
        $('[data-toggle="popover"]').popover();
      }, 500);
    });
  },
  data() {
    return {
      file_validation: false,
      tempRemoveObj: null,
      tempRemoveName: null,
      project: {},
      loading: false,
      otherInfo: {
        // business_incubator: null,
        how_found_us: null,
        mention_id: null,
        awards: {}
      },
      awards: {},
      mentions: {},
      editionQueries:[],
      projectQueries: [],
      tab: 1,
      needDocumentation: false,
      titles: {
        1: "Informazioni aggiuntive",
        2: "Volete concorrere a qualcuno dei premi speciali?",
        3: "Volete concorrere a qualcuna delle menzioni speciali?",
      },
      loading_award_document: false,
      loading_mention_document: false,
      file_error: false,
    };
  },
  validations: {
    otherInfo: {
    //   business_incubator: { required },
      how_found_us: { required },
    },
  },
  methods: {
    saveForLater() {
      if (this.loading) return this.$toasted.error(this.$t("is_uploading"));

      this.$v.$touch();

      this.otherInfo.later = true;
      this.otherInfo.awards = this.awards;
      this.otherInfo.mentions = this.mentions;

      if (!this.$v.$anyError && this.checkFiles()) {
        axios.post(this.route, this.otherInfo).then((response) => {
          window.location.href = response.data.redirect;
        });
      }
    },
    next() {
      if (this.loading) return this.$toasted.error(this.$t("is_uploading"));

      this.$v.$touch();

      this.otherInfo.awards = this.awards;
      this.otherInfo.mentions = this.mentions;

      if (!this.$v.$anyError && this.checkFiles()) {
        if (this.tab === 3) {
          axios.post(this.route, this.otherInfo).then((response) => {
            window.location.href = response.data.redirect;
          });
        } else {
          this.tab++;
        }
      }
    },
    previous() {
      if (this.loading) return this.$toasted.error(this.$t("is_uploading"));

      this.tab > 1 && this.tab <= 3 ? this.tab-- : (window.location.href = this.previousRoute);
    },
    showHideLabel(label) {
      var x = document.getElementById(label + "_label");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        var my_label = "this.otherInfo." + label;

        if (!eval(my_label)) x.style.display = "none";
      }
    },
    handleFileUpload(obj, title) {
      // document.getElementById(title + "-" + obj.id).disabled = true;

      if (title === "award") var new_file = this.$refs["award_" + obj.id][0].files[0];
      else if (title === "mention") var new_file = this.$refs["mention_" + obj.id][0].files[0];

      if (new_file !== undefined) {
        var self = this;

        obj.file = null;

        let formData = new FormData();
        formData.append("file", new_file);
        formData.append("title", title);
        formData.append("additional_id", obj.id);
        formData.append("project_name", self.otherInfo.name);
        formData.append("name", "F2_" + title + "_" + obj.id + "_" + self.otherInfo.name + ".pdf");

        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };

        this.loading = true;
        self.loaderOn(title);

        axios
          .post(this.fileRoute, formData, config)
          .then((response) => {
            this.loading = false;
            self.loaderOff(title);
            obj.file = new_file.name;
          })
          .catch((error) => {
            this.loading = false;
            this.loaderOff(title);
            if (error.response.data.errors) {
              this.$toasted.error(this.$t("must_be_pdf"));
            }
          });
      }
    },
    openDeleteModal(obj, name) {
      this.tempRemoveObj = obj;
      this.tempRemoveName = name;
      $("#remove_file_modal").modal();
    },
    removeFile() {
      var self = this;
      $("#remove_file_modal").modal("hide");
      this.loaderOn(this.tempRemoveName);
      this.tempRemoveObj.file = null;

      let formData = new FormData();
      /*formData.append(
          "name",
          "F2_" +
          this.tempRemoveName +
          "_" +
          this.tempRemoveObj.id +
          "_" +
          this.otherInfo.name +
          ".pdf"
      );*/
      formData.append("name", this.tempRemoveObj.file);
      this.tempRemoveObj.file = null;
      formData.append("title", this.tempRemoveName);

      axios.post(this.deleteFileRoute, formData).then((response) => {
        self.loaderOff(self.tempRemoveName);
        document.getElementById(self.tempRemoveName + "-" + self.tempRemoveObj.id).disabled = false;
      });
    },
    loaderOn(title) {
      if (title === "mention") this.loading_mention_document = true;
      if (title === "award") this.loading_award_document = true;
    },
    loaderOff(title) {
      if (title === "mention") this.loading_mention_document = false;
      if (title === "award") this.loading_award_document = false;
    },
    hasFile(award) {
      if (award.file == null && award.selected == true) {
        return false;
      } else {
        return true;
      }
    },
    checkFiles() {
      var self = this;
      var bool = true;

      if (this.tab === 2) {
        this.awards.forEach(function (a) {
          if (a.selected && a.file == null && a.needs_documentation) {
            bool = false;
            self.file_validation = true;
          }
        });
      }

      if (this.tab === 3) {
        this.mentions.forEach(function (m) {
          if (m.selected && m.file == null && m.needs_documentation) {
            bool = false;
            self.file_validation = true;
          }
        });
      }

      return bool;
    },
  },
};
</script>

<style scoped>
.bg-yellow {
  background-color: #f2b12d;
}
</style>
